import { render, staticRenderFns } from "./CourseNameForm.vue?vue&type=template&id=74613051&scoped=true"
import script from "./CourseNameForm.vue?vue&type=script&lang=js"
export * from "./CourseNameForm.vue?vue&type=script&lang=js"
import style0 from "./CourseNameForm.vue?vue&type=style&index=0&id=74613051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74613051",
  null
  
)

export default component.exports